import {
    ReactElement,
} from 'react';

import {
    SimpleGrid,
    Table,
} from '@mantine/core';

import {useApplicationScreenshots} from '../hooks/useApplicationScreenshots.ts';
import {useApplicationScreenshotsFilter} from '../hooks/useApplicationScreenshotsFilter.ts';

import {
    RowSelectionDataCell,
    SimpleTableBatchAction,
    SimpleTablePagination,
    TableBody,
    TableBodyColumn,
    TableHeaderColumn,
    TableHeaderRow,
} from '@flexinet/ui-components';
import {useApplicationScreenshotsSelection} from '../hooks/useApplicationScreenshotsSelection.ts';
import {IApplicationScreenshotTableColumn,} from '../types';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {useApplicationScreenshotsPaging} from "../hooks/useApplicationScreenshotsPaging.ts";
import {useApplicationScreenshotsSearch} from "../hooks/useApplicationScreenshotsSearch.ts";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions()

    const {filters} = useApplicationScreenshotsFilter();

    const {
        columns,
        visibleItems,
        loading,
    } = useApplicationScreenshots(filters);

    const {
        limit,
        totalPages,
        totalCount,
        handleItemsPerPageChange,
        handlePageChange,
    } = useApplicationScreenshotsPaging();

    const {
        handleFilterByKeyword,
    } = useApplicationScreenshotsSearch();

    const {
        selection,
        handleRowSelection,
        handleSelectAllRows,
    } = useApplicationScreenshotsSelection();
    const getColumns = () => {
        let cols: IApplicationScreenshotTableColumn[] = [];
        if (allowedActions.includes('DeleteApplicationScreenshot')) {

            cols.push({
                          id: 'select',
                          title: '',
                          render: (item: any) => {
                              return <RowSelectionDataCell item={item} handleChange={() => handleRowSelection(item.id, !selection[item.id])}/>;
                          },


                      },
            );
        }

        cols = cols.concat(columns);

        return cols;

    };


    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />
            <Table verticalSpacing='sm' striped highlightOnHover>
                <TableHeaderRow
                    columns={getColumns() as TableHeaderColumn[]}
                    handleSelectAllRows={() => handleSelectAllRows(!Object.keys(selection).length, visibleItems)}
                />
                <TableBody
                    items={visibleItems}
                    loading={loading}
                    selection={selection as any}
                    columns={getColumns() as TableBodyColumn[]}
                />
            </Table>

            <SimpleTablePagination
                totalPages={totalPages}
                visibleCount={totalCount}
                handlePageChange={handlePageChange}
            />
        </SimpleGrid>
    );
};
